import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IDeleteBlockMutationParameters {
    productId: string;
    variantId: string;
    blockId: string;
}

export const useDeleteBlock = (
    invalidQueryKeys: string | string[],
): UseMutationResult<void, unknown, IDeleteBlockMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<void, unknown, IDeleteBlockMutationParameters>({
        mutationFn: async (parameters: IDeleteBlockMutationParameters) => {
            if (!auth.token) {
                throw new Error("Cannot delete block without authorization token.");
            }

            return await api.Products.deleteBlock(
                parameters.productId,
                parameters.variantId,
                parameters.blockId,
                auth.token,
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
